/** Mapbox Standard theme values (setConfigProperty "basemap", "theme"). */
export type MapStyleVariantValue = "default" | "faded" | "monochrome";

export const MAP_STYLE_VARIANT_DEFAULT: MapStyleVariantValue = "default";

export function normalizeMapStyleVariant(
  v: string | null | undefined,
): MapStyleVariantValue {
  if (v === "faded" || v === "monochrome") return v;
  return "default";
}
